import styled from 'styled-components';

import { ErrorType } from 'types';

import { pickColor } from 'themes/helpers/pickColor';
import { FontScale, getFontScale } from 'themes/mixins/getFontScale';

import { Button } from 'components/Button';

import { InputMotives, pickMotive } from './inputMotives.data';

export type StyledInputProps = {
  error?: ErrorType;
  scale?: FontScale;
  motive?: InputMotives;
};

const Wrapper = styled.div<StyledInputProps>`
  position: relative;
  display: flex;

  ${({ motive }) => motive && pickMotive(motive)};
  ${({ scale }) => scale && getFontScale(scale)};
`;

const Container = styled.div`
  position: relative;

  width: 100%;
`;

const Input = styled.input<StyledInputProps>`
  display: block;

  width: 100%;

  color: ${pickColor('grayDark')};

  ${({ scale }) => scale && getFontScale(scale)};

  &:disabled {
    background-color: ${pickColor('gray')};
    border-color: ${pickColor('borderDisabled')};
  }
`;

const PasswordButton = styled(Button)`
  position: absolute;

  top: 50%;
  right: 1.7rem;

  transform: translateY(-50%);
`;

const ClearButton = styled(Button)`
  position: absolute;

  top: 50%;
  right: 1rem;

  padding: 0.2rem;
  background: transparent;
  border: none;

  transform: translateY(-50%);

  color: ${pickColor('grayDark')};

  cursor: pointer;

  &:hover {
    color: ${pickColor('black')};
  }
`;

export { ClearButton, Container, Input, PasswordButton, Wrapper };
